// extracted by mini-css-extract-plugin
export default {"container":"uN-z","topReviewHeading":"vN-z","criticalReview":"wN-z","favorableReview":"xN-z","vsSeparator":"yN-z"};